import { getAge } from 'services/utils'
import { Ability, abilityKeys } from './interfaces/IAbilityData'

export const trackedAbilities = (child: any) => {
  const res = [
    Ability.attention,
    Ability.executiveFunctions,
    Ability.math,
    Ability.memory,
    Ability.selfEsteem,
    Ability.social,
    Ability.spatial
  ]

  const currentAssessmentTimestamp = child.currentAssessment

  const age = getAge(child.birth_date, Number(currentAssessmentTimestamp))

  if (age >= 3 && age < 8) {
    res.push(Ability.motor)
  }
  if (age >= 3 && age < 9) {
    res.push(Ability.language)
  }

  return res
}

export const notTrackedAbilities = (child: any) => {
  const tracked = trackedAbilities(child)
  return abilityKeys.filter(abilityKey => !tracked.includes(abilityKey))
}

export default {
  trackedAbilities,
  notTrackedAbilities
}



// WEBPACK FOOTER //
// ./src/data/abitilies/childsAbilities.ts